import IdentityVerification from '@/features/Application/identity-verification'
import SocialVerification from '@/features/Application/social-verification'
import EmploymentVerification from '@/features/Application/employment-verification'
import IncomeVerification from '@/features/Application/income-verification'

const View = ({ data, application, isLocked, isLoading, standalone = false }) => {
  return (
    <>
      <IdentityVerification
        data={data?.identity}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <SocialVerification data={data?.social} isLocked={isLocked} isLoading={isLoading} />
      <EmploymentVerification
        data={data?.employment}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <IncomeVerification
        data={data?.income}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
    </>
  )
}

export default View
